// Composer "Thinking" selection — which reasoning_effort to send with the
// next turn. Per-model, because the allowed values differ by model (see the
// backend's providers/reasoning_specs.py): "high" on grok-4.5 and "high" on
// gemini-3.1-pro are unrelated choices, and a model that doesn't support the
// field at all must not inherit a stale selection from one that does.
// localStorage, same posture as chatModel.ts and memoryPrefs.ts — there is no
// per-user settings table server-side.
const KEY = "chatclient.thinkingEffort";

type Store = Record<string, string>;

function read(): Store {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? (parsed as Store) : {};
  } catch {
    return {};
  }
}

/** `null` means "provider default" — the field is omitted from the request. */
export function loadThinkingEffort(modelKey: string, allowed: string[]): string | null {
  const value = read()[modelKey];
  return value && allowed.includes(value) ? value : null;
}

export function saveThinkingEffort(modelKey: string, value: string | null): void {
  try {
    const store = read();
    if (value) store[modelKey] = value;
    else delete store[modelKey];
    localStorage.setItem(KEY, JSON.stringify(store));
  } catch {
    // Storage is a convenience, not a requirement for the current session.
  }
}
